import { render, staticRenderFns } from "./charcolor.vue?vue&type=template&id=199a739e&scoped=true"
import script from "./charcolor.vue?vue&type=script&lang=js"
export * from "./charcolor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a739e",
  null
  
)

export default component.exports